<h2>{{message}}</h2>
<p>Click <a routerLink="/">here</a> to go back home
</p>
